import { Theme, createStyles, makeStyles } from '@forgeglobal/design-framework';

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    pageContainer: {
      marginTop: theme.spacing(4),
      paddingLeft: theme.spacing(4),
      paddingRight: theme.spacing(4),
    },
    sectionSpacing: {
      marginTop: theme.spacing(4),
    },
    card: {
      maxWidth: 1200,
    },
    cardContent: {
      padding: theme.spacing(4),
    },
    titleRow: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'flex-start',
      gap: theme.spacing(0.5),
    },
    title: {
      fontWeight: 700,
    },
    email: {
      opacity: 0.7,
    },
    bannerWrapper: {
      marginTop: theme.spacing(2),
    },
    bannerText: {
      color: theme.palette.error.dark,
    },
    grid: {
      marginTop: theme.spacing(4),
      display: 'grid',
      gridTemplateColumns: 'repeat(3, minmax(0, 1fr))',
      columnGap: theme.spacing(3),
      rowGap: theme.spacing(3),
      [theme.breakpoints.down('md')]: {
        gridTemplateColumns: 'repeat(2, minmax(0, 1fr))',
      },
      [theme.breakpoints.down('sm')]: {
        gridTemplateColumns: '1fr',
      },
    },
    gridCell: {
      minWidth: 0,
    },
    label: {
      display: 'block',
      marginBottom: theme.spacing(0.5),
      opacity: 0.7,
    },
    value: {
      fontWeight: 700,
      wordBreak: 'break-word',
    },
  }),
);
